import { render } from "./WhoNextDepartment.vue?vue&type=template&id=929c6926"
import script from "./WhoNextDepartment.vue?vue&type=script&lang=js"
export * from "./WhoNextDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__